import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Text,
  Button,
  useToast,
  Box,
  Flex,
  CloseButton,
  UnorderedList,
  ListItem,
  useColorModeValue,
} from '@chakra-ui/react';
import axios from 'axios';
import { FiUpload } from 'react-icons/fi';
import baseUrl from 'Base_Url/baseUrl';
import Swal from 'sweetalert2';

const BulkUploadModal = ({ isOpen, onClose, uploadFile, setUploadFile }) => {
  const toast = useToast();
  const [isUploading, setIsUploading] = useState(false);
  const modalBg = useColorModeValue('gray.50', 'gray.800');
  const formBg = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.300', 'gray.600');
  const textColor = useColorModeValue('gray.700', 'gray.100');
  const subTextColor = useColorModeValue('gray.500', 'gray.400');
  const fileNameColor = useColorModeValue('green.600', 'green.300');
  const uploadHoverBg = useColorModeValue('gray.100', 'gray.600');
  const footerBg = useColorModeValue('gray.100', 'gray.700');

  // const handleUpload = async () => {
  //   if (!uploadFile) {
  //     toast({
  //       title: 'Please select a file.',
  //       status: 'warning',
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append('file', uploadFile);
  //   formData.append('status', 'talatiview');

  //   setIsUploading(true);

  //   try {
  //     const token = localStorage.getItem('token');
  //     const response = await axios.post(
  //       `${baseUrl}/survey/bulk-upload`,
  //       formData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           'Content-Type': 'multipart/form-data',
  //         },
  //       }
  //     );

  //     const result = response.data?.data;
  //     const message = result?.message || 'Upload successful.';

  //     toast({
  //       title: 'Upload Result',
  //       duration: 10000,
  //       isClosable: true,
  //       position: 'top',
  //       render: ({ onClose }) => (
  //         <Box
  //           p={4}
  //           pr={10}
  //           color="black"
  //           bg="green.100"
  //           borderRadius="md"
  //           boxShadow="md"
  //           position="relative"
  //         >
  //           <CloseButton position="absolute" right="8px" top="8px" mb={2} onClick={onClose} />
  //           <Text fontWeight="semibold" mb={2}>{message}</Text>
  //           {result?.errorDetails?.length > 0 && (
  //             <>
  //               <Text fontWeight="bold" mt={2}>Errors:</Text>
  //               <Box maxHeight="120px" overflowY="auto" mt={1} pr={1}>
  //                 <UnorderedList spacing={1}>
  //                   {result.errorDetails.map((err, idx) => (
  //                     <ListItem key={idx}>{err}</ListItem>
  //                   ))}
  //                 </UnorderedList>
  //               </Box>
  //             </>
  //           )}
  //         </Box>
  //       ),
  //     });

  //     setUploadFile(null);
  //     onClose();
  //   } catch (error) {
  //     const errorDetails = error?.response?.data?.data?.errorDetails;
  //     const message = error?.response?.data?.data?.message || 'Upload failed.';

  //     toast({
  //       title: 'Upload Failed',
  //       duration: 10000,
  //       isClosable: true,
  //       position: 'top',
  //       render: ({ onClose }) => (
  //         <Box
  //           p={4}
  //           pr={10}
  //           color="black"
  //           bg="red.100"
  //           borderRadius="md"
  //           boxShadow="md"
  //           position="relative"
  //         >
  //           <CloseButton position="absolute" right="8px" top="8px" mb={2} onClick={onClose} />
  //           <Text fontWeight="semibold" mb={2}>{message}</Text>
  //           {errorDetails?.length > 0 && (
  //             <>
  //               <Text fontWeight="bold" mt={2}>Errors:</Text>
  //               <Box maxHeight="120px" overflowY="auto" mt={1} pr={1}>
  //                 <UnorderedList spacing={1}>
  //                   {errorDetails.map((err, idx) => (
  //                     <ListItem key={idx}>{err}</ListItem>
  //                   ))}
  //                 </UnorderedList>
  //               </Box>
  //             </>
  //           )}
  //         </Box>
  //       ),
  //     });
  //   } finally {
  //     setIsUploading(false);
  //   }
  // };

  const handleUpload = async () => {
    if (!uploadFile) {
      Swal.fire({
        title: 'No file selected',
        text: 'Please select a file to upload.',
        icon: 'warning',
      });
      return;
    }

    const formData = new FormData();
    formData.append('file', uploadFile);
    formData.append('status', 'talatiview');

    setIsUploading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${baseUrl}/survey/bulk-upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      const result = response.data?.data;
      const message = result?.message || 'Upload successful.';

      if (result?.errorDetails?.length > 0) {
        Swal.fire({
          title: 'Upload completed with errors',
          html: `
          <div style="text-align:left;">
            <strong>${message}</strong>
            <ul style="margin-top:10px;">
              ${result.errorDetails.map((e) => `<li>${e}</li>`).join('')}
            </ul>
          </div>
        `,
          icon: 'warning',
          width: 600,
          confirmButtonColor: '#3182ce',
        });
      } else {
        Swal.fire({
          title: 'Success!',
          text: message,
          icon: 'success',
          confirmButtonColor: '#3182ce',
        });
      }

      setUploadFile(null);
      onClose();
    } catch (error) {
      const errorDetails = error?.response?.data?.data?.errorDetails || [];
      const message = error?.response?.data?.data?.message || 'Upload failed.';

      Swal.fire({
        title: 'Upload failed',
        html: `
        <div style="text-align:left;">
          <strong>${message}</strong>
          ${
            errorDetails.length > 0
              ? `<ul style="margin-top:10px;">${errorDetails
                  .map((e) => `<li>${e}</li>`)
                  .join('')}</ul>`
              : ''
          }
        </div>
      `,
        icon: 'error',
        width: 600,
        confirmButtonColor: '#e53e3e',
      });
    } finally {
      setIsUploading(false);
    }
  };

  const handleClose = () => {
    setUploadFile(null);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="lg" boxShadow="xl">
        <ModalHeader bg="blue.600" color="white" py={3} borderTopRadius="lg">
          Upload Historic Data
        </ModalHeader>
        <ModalCloseButton color="white" />

        <ModalBody py={6} px={6} bg="gray.50">
          <FormControl isRequired>
            <FormLabel fontWeight="semibold" fontSize="sm" color={textColor}>
              Upload Excel File (.xlsx)
            </FormLabel>

            <Box
              border="2px dashed"
              borderColor={borderColor}
              borderRadius="md"
              p={6}
              textAlign="center"
               bg={formBg}
               _hover={{ borderColor: 'blue.400', bg: uploadHoverBg }}
              cursor="pointer"
              position="relative"
            >
              <Flex direction="column" align="center" justify="center">
                <FiUpload size={28} color="#718096" />
                <Text fontSize="sm" color={subTextColor}mt={2}>
                  Drag & drop or click to select a file
                </Text>
              </Flex>

              <Input
                type="file"
                accept=".xlsx"
                onChange={(e) => setUploadFile(e.target.files[0])}
                position="absolute"
                top="0"
                left="0"
                width="100%"
                height="100%"
                opacity="0"
                cursor="pointer"
              />
            </Box>

            {uploadFile && (
              <Text mt={2} fontSize="xl" color={fileNameColor} isTruncated>
                Selected File: {uploadFile.name}
              </Text>
            )}

            <Text fontSize="xs" mt={2} color={subTextColor}>
              Please upload a valid Excel (.xlsx) file according to the selected
              format.
            </Text>
          </FormControl>
        </ModalBody>

        <ModalFooter bg={footerBg} borderBottomRadius="lg">
          <Button onClick={handleClose} variant="ghost" mr={3}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            px={6}
            onClick={handleUpload}
            isDisabled={!uploadFile || isUploading}
            isLoading={isUploading}
            loadingText="Uploading"
          >
            Upload
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BulkUploadModal;
